import service from "@hybird/core/request";
import request from "@hybird/device/request";
import {BeginSealDeviceMethodInterceptor} from "@hybird/device/interceptor/beginSeal/core";
import {DeviceEvent} from "@hybird/core/device/protocol";

export class EquipmentRecBeginSealInterceptor extends BeginSealDeviceMethodInterceptor {

  static sendVideoCut = true;

  async beginSeal(proceed, self, params = {}) {
    const deviceProtocolBeginSeal = self;

    deviceProtocolBeginSeal.option.businessKey = await deviceProtocolBeginSeal.getBusinessKeySend();
    const result = await proceed(params);

    deviceProtocolBeginSeal.on(DeviceEvent.DOCUMENT_STATE_UPLOADING, async (data) => {
      if (deviceProtocolBeginSeal.deviceInfo.equipmentRec === 1) {
        const time = parseInt(Number((new Date().getTime() - deviceProtocolBeginSeal.beginSealTime) / 1000).toFixed(0));

        await this.send(deviceProtocolBeginSeal, time - 5, time + 5, 2);
      }
    })
  }

  async remoteLock(proceed, self, params = {}) {
    const deviceProtocolBeginSeal = self;
    const result = await proceed(params);

    if (!self.remoteLockStatus && !self.beforeLockTime) {
      const start = Number((self.beforeLockTime - self.beginSealTime) / 1000).toFixed(0);
      const end = Number((self.unlockTime - self.beginSealTime) / 1000).toFixed(0);

      await this.send(deviceProtocolBeginSeal, start, end);
    }

    return result;
  }

  send(deviceProtocolBeginSeal, start, end, type = 1) {
    return service.post(request.videoCut, {
      'operationId': deviceProtocolBeginSeal?.deviceInfo.operationId,
      'leftTimes': deviceProtocolBeginSeal?.deviceInfo?.leftTimes,
      'coverId': deviceProtocolBeginSeal?.deviceInfo?.coverId,
      'cutEnd': end <= 0 ? 0 : end,
      'cutStart': start <= 0 ? 0 : start,
      'documentId': deviceProtocolBeginSeal.deviceInfo.documentId,
      'equipmentNumber': deviceProtocolBeginSeal.deviceInfo.number,
      'sealId': deviceProtocolBeginSeal.deviceInfo.sealId,
      'videoType': type,
      'businessKey': deviceProtocolBeginSeal.option.businessKey
    })
  }

  isSupport(self) {
    return self.deviceInfo.equipmentRec === 1;
  }
}
